
    <div class="datatable-body-cell-label">
      <label
        *ngIf="column.checkboxable && (!displayCheck || displayCheck(row, column, value))"
        class="datatable-checkbox">
        <input
          type="checkbox"
          [checked]="isSelected"
          (click)="onCheckboxChange($event)"
        />
      </label>
      <span
        *ngIf="!column.cellTemplate"
        [title]="sanitizedValue"
        [innerHTML]="value">
      </span>
      <ng-template #cellTemplate
        *ngIf="column.cellTemplate"
        [ngTemplateOutlet]="column.cellTemplate"
        [ngTemplateOutletContext]="cellContext">
      </ng-template>
    </div>
  


// WEBPACK FOOTER //
// ./node_modules/@swimlane/ngx-datatable/release/components/body/body-cell.component.d.ts.DataTableBodyCellComponent.html